import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { env } from './env';

/**
 * Obtiene una imagen del usuario.
 *  - Android: diálogo nativo (cámara o galería) con @capacitor/camera.
 *  - Web: selector de archivos (en móviles permite usar la cámara).
 * Devuelve null si el usuario cancela.
 */
export async function pickImage(source: 'prompt' | 'camera' | 'gallery' = 'prompt'): Promise<Blob | null> {
  if (env.isNative) {
    try {
      const photo = await Camera.getPhoto({
        resultType: CameraResultType.Uri,
        source: source === 'camera' ? CameraSource.Camera : source === 'gallery' ? CameraSource.Photos : CameraSource.Prompt,
        quality: 85,
        width: 1600,
        correctOrientation: true,
        promptLabelHeader: 'Foto',
        promptLabelPhoto: 'Elegir de la galería',
        promptLabelPicture: 'Tomar foto',
        promptLabelCancel: 'Cancelar',
      });
      if (!photo.webPath) return null;
      return await (await fetch(photo.webPath)).blob();
    } catch (e) {
      if (String((e as Error).message).toLowerCase().includes('cancel')) return null;
      throw e;
    }
  }
  return pickFile('image/jpeg,image/png,image/webp', source === 'camera');
}

export function pickFile(accept: string, capture = false): Promise<Blob | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    if (capture) input.setAttribute('capture', 'environment');
    input.onchange = () => resolve(input.files?.[0] ?? null);
    // Si el usuario cierra el diálogo no hay evento estándar; se resuelve al recuperar el foco.
    window.addEventListener('focus', () => setTimeout(() => !input.files?.length && resolve(null), 800), { once: true });
    input.click();
  });
}

export function toForm(blob: Blob, fields: Record<string, string> = {}, filename = 'archivo'): FormData {
  const form = new FormData();
  for (const [k, v] of Object.entries(fields)) form.append(k, v);
  const ext = blob.type === 'application/pdf' ? 'pdf' : blob.type.split('/')[1] ?? 'jpg';
  form.append('file', blob, `${filename}.${ext}`);
  return form;
}
